<template>
  <div
    class="align-center background-color-white d-flex flex-column full-width pb-5 pt-10 px-7"
  >
    <div class="font-size-lg font-weight-semibold text-center">
      Welcome to {{ wait(storeInfo, "name") }}
    </div>
    <div
      class="color-fire-engine-red"
      v-if="fromLogin || (fromMobileLoginRoute && !account && !authorized)"
    >
      Account Does Not Exist
    </div>
    <div class="font-weight-semibold mb-4 text-center">Sign Up</div>
    <v-form
      ref="form"
      v-model="valid"
      class="full-width"
      @submit.prevent="toConfirmation"
    >
      <NameInput
        :name="identification.firstName"
        :type="'firstName'"
        :update="updateIdentification"
        autofocus
      />
      <NameInput
        :name="identification.lastName"
        :type="'lastName'"
        :update="updateIdentification"
      />
      <PhoneInput :phone="identification.phone" :updatePhone="updatePhone" />
      <div class="font-weight-semibold mb-3 text-center">
        We will send you a confirmation code to this number
      </div>
      <v-btn
        class="mb-3"
        color="success"
        :disabled="!valid"
        type="submit"
        block
        large
        rounded
      >
        <div class="font-size-md font-weight-semibold text-capitalize">
          next
        </div>
      </v-btn>
    </v-form>
    <div class="font-size-xxs">
      By entering your phone number and pressing "Next" you consent to receive
      automated text messages from National Retail Solutions regarding your
      account and orders at that number. Consent is not a condition of purchase.
      Msg&Data rates may apply.
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { Steps } from "@/types/signup.js";
import { wait } from "@/util.js";
import NameInput from "@/components/Inputs/Name.vue";
import PhoneInput from "@/components/Inputs/Phone.vue";

export default {
  name: "SignUpIdentificationContent",
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromMobileLoginRoute = from.path === "/login/sms";
    });
  },
  components: {
    NameInput,
    PhoneInput,
  },
  computed: {
    ...mapGetters({
      authorized: "auth/isAuthenticated",
    }),
    ...mapState({
      account: (state) => state.auth.account,
      storeInfo: (state) => state.store.info,
    }),
  },
  data() {
    return {
      fromMobileLoginRoute: null,
      valid: true,
    };
  },
  methods: {
    async toConfirmation() {
      this.$refs.form.validate();
      if (!this.valid) {
        return;
      }
      this.$store.dispatch("auth/sendVerificationCodeToPhone", {
        country_code: 1,
        phone_number: this.identification.phone,
      });
      this.to
        ? this.to(Steps.confirmation)
        : this.$router.push({ name: Steps.confirmation });
    },
    wait,
  },
  props: {
    fromLogin: Boolean,
    identification: Object,
    to: Function,
    updateIdentification: Function,
    updatePhone: Function,
  },
};
</script>
